<template>
    <div class="video-list" v-if="dataList.length != 0">
        <swiper :options="swiperOption">
            <!-- 幻灯内容 -->
            <!-- 循环输出 -->
            <swiper-slide v-for="(item,index) in dataList" :key="item.id">
                <div class="video_wrap">
                    <!-- ref：节点 -->
                    <videos
                        ref="videos"
                        :videoList="item"
                        :index="index"
                        :cur_index="page - 1"
                        :isIOS="isIOS"
                    ></videos>
                </div>
                <div class="infobar-warp">
                    <info-bar :title="item.title" :publishDate="item.publishDate" :from="item.from"></info-bar>
                </div>
                <div class="right-warp">
                    <right-bar
                        :headerimg="item.headerimg"
                        :jianjielink="item.jianjielink"
                        :sharetext="item.sharetext"
                        :clicknum="item.clicknum"
                        :title="item.title"
                        :des="item.des"
                    ></right-bar>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>
  
<script>
//导入swiper组件'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import InfoBar from './InfoBar'
import RightBar from './RightBar'
import { browser } from "../util/video_article";

//导入播放组件
import Videos from './Videos'
export default {
    name: 'VideoList',
    components: {
        //注册swiper组件
        Swiper,
        SwiperSlide,
        Videos,
        InfoBar,
        RightBar
    },
    props: {
        dataList: []
    },
    methods: {
        async playAction(index) {
            await this.$refs.videos[index].playOrStop()
        },
        //上滑
        async nextVideo(index) {
            //通过DOM元素来获取子组件的方法
            //上一个视频停止
            await this.$refs.videos[index - 1].stop();
            if (!this.isIOS) {
                //下一个视频开始
                await this.$refs.videos[index].play();
            }

        },
        //下滑
        async preVideo(index) {
            await this.$refs.videos[index + 1].stop();
            if (!this.isIOS) {
                await this.$refs.videos[index].play();
            }

        },
        //弹出评论
        showCom() {
            this.showComment = true;
        },
        close() {
            this.showComment = false;
        }


    },
    // directives:{
    //   swiper:directive
    // },
    data() {

        return {
            showComment: false,
            page: 1,
            isIOS: browser.versions.ios,
            swiperOption: {
                //垂直方向滑动
                direction: "vertical",
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
                slidesPerView: 1,
                mousewheel: true,
                mousewheelControl: true,
                // 高度设置，占满设备高度
                height: window.innerHeight,
                resistanceRatio: 0,
                observeParents: true,
                on: {
                    //详见：https://www.swiper.com.cn/api/event/226.html
                    tap: () => {
                        console.log("tap")
                        this.playAction(this.page - 1);
                    },
                    //上滑
                    //详见：https://www.swiper.com.cn/api/event/290.html
                    slideNextTransitionStart: () => {
                        // alert('开始切换');
                        this.page += 1;
                        this.nextVideo(this.page - 1);
                        console.log(this.page);
                    },
                    slidePrevTransitionStart: () => {
                        if (this.page > 1) {
                            this.page -= 1;
                            this.preVideo(this.page - 1);
                            console.log(this.page);
                        }
                    }
                }
            },
        }
    }
}
</script>



<style scoped>
.video_wrap {
    background-color: #000000;
}
.video-list {
    height: 100%;
}
.swiper-container {
    height: 100%;
    position: relative;
}
.infobar-warp {
    position: absolute;
    bottom: 0.6rem;
    left: 0;
}
.right-warp {
    position: absolute;
    bottom: 3rem;
    right: 0.266667rem;
}


.comment-warp {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 500px;
    width: 100%;
    background: white;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    z-index: 999;
    padding: 10px 10px;
    box-sizing: border-box;
}
.comment-top {
    display: flex;
    align-items: center;
}
.number {
    flex-grow: 1;
    text-align: center;
}
.close {
    padding-right: 10px;
    font-size: 30px;
    color: #666;
}
.comment-body {
    max-width: 450px;
    overflow: auto;
    margin-top: 20px;
}
.comment-item {
    display: flex;
}
.user-pic img {
    height: 33px;
    width: 33px;
    border-radius: 50%;
}
.item-info {
    margin-left: 10px;
    display: flex;
    flex: 1 1 auto;
}
.reply {
    width: 90%;
}
.reply-des {
    line-height: 24px;
}
.reply .name {
    color: #666;
    font-size: 14px;
    margin-bottom: 10px;
}
.reply .time {
    color: #666;
}
.zan {
    text-align: center;
}
.zan .iconfont {
    font-size: 20px;
}
.zan p {
    color: #cccccc;
    margin-top: 5px;
}

.reply-input {
    width: 100%;
    height: 50px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #ffffff;
    display: flex;
    align-items: center;
}
.reply-input input {
    line-height: 40px;
    width: 70%;
    border: none;
    padding: 0 10px;
}
.reply-input .at1 {
    font-size: 30px;
    color: #cccccc;
    margin-right: 8%;
}
.reply-input .iconfont {
    font-size: 30px;
    color: #cccccc;
}
</style>